import { EnvironmentType } from './types';

export const environment: EnvironmentType = {
  appVersion: `v ${require('../../package.json').version} (beta)`,
  production: true,
  baseUrl: 'https://lk.unions.me',
};
